/*const pages = [
  {
    url: "/",
    title: "About",
    disabled: false,
  },
  {
    url: "/",
    title: "Contact Us",
    disabled: false,
  },
  {
    url: "/",
    title: "Sign Up",
    disabled: false,
  },
  {
    url: "/",
    title: "Login",
    disabled: false,
  },
];*/

const pages = [];

const config = {
  pages,
};

export default config;
